// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__UgZaK","leftTop":"index_leftTop__T1Rca","leftBottom":"index_leftBottom__U_61n","rightTop":"index_rightTop__ZokBV","rightBottom":"index_rightBottom__6Qxva"};